import React from "react";

import { SelectInput } from "../../../../common/form";
import PropTypes from "prop-types";
import BrokerSection from "./BrokerSection";
import BrokerLanguageField from "./BrokerLanguageField";
import BrokerField from "./BrokerField";

const translationContext = "admin.brokers.";

const BrokerGeneral = ({ translateFn }) => {
  const typesOptions = ["BROKER", "FIRM"].map((value) => ({
    value,
    key: `${translationContext}${value.toLowerCase()}`,
  }));

  return (
    <BrokerSection title={translateFn("generalInformation")}>
      <BrokerField translateFn={translateFn} name={"identificationNumber"} />
      <BrokerField translateFn={translateFn} name={"acombaNumber"} />
      <BrokerField
        translateFn={translateFn}
        required={true}
        name={"fullName"}
      />
      <BrokerField
        translateFn={translateFn}
        required={true}
        name={"emailAddress"}
        extraProps={{ type: "email" }}
      />
      <BrokerField translateFn={translateFn} name={"phoneNumber"} />
      <BrokerLanguageField
        translateFn={translateFn}
        name={"contactLanguageCode"}
      />
      <BrokerField
        translateFn={translateFn}
        name={"type"}
        extraProps={{ component: SelectInput, options: typesOptions }}
      />
      <BrokerField translateFn={translateFn} name={"affiliatedFirm"} />
    </BrokerSection>
  );
};

BrokerGeneral.propTypes = {
  translateFn: PropTypes.func.isRequired,
};

export default BrokerGeneral;



// WEBPACK FOOTER //
// ./src/components/dashboard/admin/brokers/formSections/BrokerGeneral.js